import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreRoutingModule } from './core-routing.module';
import { MatCardModule, MatButtonModule, MatRadioModule,
  MatDividerModule, MatFormFieldModule, MatIconModule, MatInputModule, MatExpansionModule, MatGridListModule,
  MatListModule, MatTableModule, MatSelectModule, MatAutocompleteModule, MatOptionModule, MatDialogModule,
  MatPaginatorModule,
  MatProgressSpinnerModule,
  MatSnackBarModule,
  MatSortModule,
  MatSlideToggleModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MAT_DATE_LOCALE,
  MatProgressBarModule, MatTabsModule} from '@angular/material';
import { HttpClientModule } from '@angular/common/http';
import { UtilityService } from './shared/utility.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MessagesComponent } from './messages/messages.component';
import { SelectItemDialogComponent } from './modal/select-item-dialog/select-item-dialog.component';
import { SelectCollageDialogComponent } from './modal/select-collage-dialog/select-collage-dialog.component';
import { ConfirmationDialogComponent } from './modal/confirmation-dialog/confirmation-dialog.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { SnackbarMessageComponent } from './snackbar-message/snackbar-message.component';
import { SelectEvaluatorDialogComponent } from './modal/select-evaluator-dialog/select-evaluator-dialog.component';
import { UserService } from '../features/requets/shared/user.service';
import { SelectSubjectsDialogComponent } from './modal/select-subjects-dialog/select-subjects-dialog.component';
import { HistoryStudentDialogComponent } from './modal/history-student-dialog/history-student-dialog.component';
import { SelectTestingDialogComponent } from './modal/select-testing-dialog/select-testing-dialog.component';
import { RegulationComponent } from './regulation/regulation.component';
import { SaveDescriptionDialogComponent } from './modal/save-description-dialog/save-description-dialog.component';
import { SelectSubjectRequestDialogComponent } from './modal/select-subject-request-dialog/select-subject-request-dialog.component';
import { ProgramService } from '../features/programs/shared/program.service';
import { UploadfileDialogComponent } from './modal/uploadfile-dialog/uploadfile-dialog.component';
import { RequestService } from '../features/requets/shared/request.service';
import { ShowFileComponent } from './file/show-file/show-file.component';



@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    CoreRoutingModule,
    FormsModule,
    HttpClientModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDividerModule,
    MatDialogModule,
    MatExpansionModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatNativeDateModule,
    MatRadioModule,
    MatSelectModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatTableModule,
    MatTabsModule,
  ],
  declarations: [MessagesComponent, SelectItemDialogComponent, SelectCollageDialogComponent, SelectSubjectsDialogComponent,
    ConfirmationDialogComponent, SpinnerComponent, SnackbarMessageComponent,
    SelectEvaluatorDialogComponent, SelectTestingDialogComponent,
    RegulationComponent, SaveDescriptionDialogComponent, SelectSubjectRequestDialogComponent,
    UploadfileDialogComponent, ShowFileComponent],
  exports: [
    CommonModule,
    CoreRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    BrowserModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatCardModule,
    MatCheckboxModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDividerModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatInputModule,
    MatIconModule,
    MatListModule,
    MatNativeDateModule,
    MatRadioModule,
    MatPaginatorModule,
    MatTableModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSortModule,
    MessagesComponent,
    ReactiveFormsModule,
    SelectItemDialogComponent,
    SelectCollageDialogComponent,
    ConfirmationDialogComponent,
    SpinnerComponent,
    SnackbarMessageComponent,
    SelectEvaluatorDialogComponent,
    SelectSubjectsDialogComponent,
    SelectTestingDialogComponent,
    RegulationComponent,
    SaveDescriptionDialogComponent,
    SelectSubjectRequestDialogComponent,
    UploadfileDialogComponent,
    ShowFileComponent,
  ],
  providers : [UtilityService, UserService, ProgramService, RequestService,
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'}
  ],
  entryComponents: [SelectItemDialogComponent,
                    SelectCollageDialogComponent,
                    ConfirmationDialogComponent,
                    SelectEvaluatorDialogComponent,
                    SelectSubjectsDialogComponent,
                    SnackbarMessageComponent,
                    SaveDescriptionDialogComponent,
                    SelectTestingDialogComponent,
                    UploadfileDialogComponent,
                    SelectSubjectRequestDialogComponent]
})
export class CoreModule { }
